import xaxios from '@/xaxios';
import {id_mod_monografia,id_mod_defen_tesis,id_mod_apostilla} from '@/views/programa_reg_from_oferta/crear-programa-esam.js'

export const headers = [
  { text: 'concepto', value: 'xnombre' },
  { text: 'nro. de cuota', value: 'nro_cuota' },
  { text: 'monto', value: 'monto' },
  { text: 'plazo de pago', value: 'fecha_pago' },
  // { text: '', value: 'num_cuota_grupo' },
];

export const rowClassX = (item) => {  
    return item.nro_cuota % 2 == 0 ? 'grupo-par' : 'grupo-impar';
};

// Si es true, se aplica un salto de un mes:
// 31/07/2026 - matricula
// 31/07/2026 - coleagitura 1
// 15/09/2026 - colegiatura 2
// 15/10/2026 - colegiatura 3
export const aplicarSaltoCuotaSiInicioMayorA15 = false;

export const realizar_inscripcion = async (input) => {
  // const url = `${process.env.VUE_APP_API_REST}/api/esam/inscripcion`;
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/inscripcion`;
  try {
    const { data } = await xaxios.post(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
}

/* export const realizar_preinscripcion = async (input) => {
  const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  try {
    const { data } = await xaxios.post(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
} */

export const realizar_inscripcion_from_preins = async (input) => {
  // const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/preinscripcion`;
  try {
    const { data } = await xaxios.put(url, input);
    return data;
  } catch (e) { 
    return e.response.data;
  }
}

export const realizar_preinscripcion_from_prospecto = async (input) => {
  const url = `${process.env.VUE_APP_API_REST}/api/esam/preinscripcion`;
  try {
    const { data } = await xaxios.post(url, input);
    return data;
  } catch (e) {
    return e.response.data;
  }
}

export const getprograma = async (id) => {
  const url = `${process.env.VUE_APP_API_REST}/esam/programa/id/` + id;
  const res = await xaxios.get(url);
  return res.data;
};

export const getpromociones = async (idprograma) => {
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/programa/${idprograma}/aprobado`;
  const res = await xaxios
    .get(url)
    .then(({ data }) => data)
    .catch((e) => e);
  return res;
};

export const getpromocionesv3 = async (idprograma,p_cobro_prog_id) => { 
  const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/promociones/v3/programa/${idprograma}/aprobado?plan_cobro_programa_id=${p_cobro_prog_id}`;
  const res = await xaxios
    .get(url)
    .then(({ data }) => data)
    .catch((e) => e);
  return res;
};


const formatFecha = (date) => {
  if (!date) return null;
  // a tods ponemos 15 de cada mes :) 
  // if(!usaFechaHoyInicial) date.setDate(15)
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

const siguienteFecha = (fechaActual) => {
  const d = new Date(fechaActual);
  const mesesASumar = aplicarSaltoCuotaSiInicioMayorA15 && d.getDate() > 15 ? 2 : 1;
  d.setDate(1);
  d.setMonth(d.getMonth() + mesesASumar);
  d.setDate(15);
  return d;
};

const sumarMeses = (date, n) => {
  const d = new Date(date);
  d.setMonth(d.getMonth() + n);
  return d;
};

const parseFechaPrograma = (fecha) => {
  if (!fecha) return null;
  if (fecha instanceof Date && !Number.isNaN(fecha.getTime())) return new Date(fecha);

  if (typeof fecha === 'string') {
    const value = fecha.trim();
    if (!value) return null;

    if (value.includes('/')) {
      const [day, month, year] = value.split('/');
      return new Date(Number(year), Number(month) - 1, Number(day));
    }

    return new Date(value.includes('T') ? value : `${value}T00:00:00`);
  }

  return null;
};

const obtenerFechaInicioPlan = (programa) => {
  window.console.log('programa', programa);
  
  // const fechaPrograma = parseFechaPrograma(programa?.fecha_inicio);
  // if (fechaPrograma && !Number.isNaN(fechaPrograma.getTime())) return fechaPrograma;

  // const fechaMatricula = parseFechaPrograma(programa?.fecha_matricula);
  // if (fechaMatricula && !Number.isNaN(fechaMatricula.getTime())) return fechaMatricula;

  const hoy = new Date();
  // comentamos esto porque creo que esta mal
  // return hoy.getDate() > 15 ? new Date(hoy) : (() => { const d = new Date(hoy); d.setDate(15); return d; })();
  return hoy
};

export const ordenarCobrosPlan = (cobros) => {
  // segun la unidad ordenar aqui los conceptos
  return cobros;
};

export const obtenerReglasInicioConceptos = () => {
  return {
    misma_fecha_inicio: [1, 2],
    tres_meses_despues_del_ultimo: [3],
    despues_del_ultimo: [],
    // fechas_nulas: [382,383,384]
    fechas_nulas: [3,385,id_mod_monografia,id_mod_defen_tesis,id_mod_apostilla]
    
  };
};

const normalizarMontoEntero = (monto) => Math.round(Number(monto) || 0);

const distribuirMontoEntero = (monto, cuotas) => {
  const total = normalizarMontoEntero(monto);
  const cantidadCuotas = Number(cuotas) || 1;
  const montoBase = Math.floor(total / cantidadCuotas);
  const sobrante = total - montoBase * cantidadCuotas;

  return Array.from({ length: cantidadCuotas }, (_, index) => montoBase + (index < sobrante ? 1 : 0));
};

export const generar_plan = (promo, cobros, programa = null) => {
  // Aplicar descuentos de promocion (clonamos para no mutar el original)
  const cobrosConDescuento = ordenarCobrosPlan(JSON.parse(JSON.stringify(cobros)));
  const reglasInicio = obtenerReglasInicioConceptos();
  if (promo && promo.detalle_promocion) {
    promo.detalle_promocion.forEach((p) => {
      const ex = cobrosConDescuento.find((c) => c.concepto_id == p.concepto_pago_id);
      if (ex) {
        let desc = 0;
        if (p.is_porcentaje) desc = parseFloat(ex.monto) * (Number(p.valor_descuento) / 100);
        else desc = parseFloat(p.valor_descuento);
        ex.monto = parseFloat(ex.monto) - desc;
        ex.promo_descuento = `${p.valor_descuento} ${p.is_porcentaje ? '%' : '$'} descuento`;
      }
    });
  }
  cobrosConDescuento.forEach((cobro) => {
    cobro.monto = normalizarMontoEntero(cobro.monto);
  });

  const fechaInicio = obtenerFechaInicioPlan(programa);

  const plan = [];
  let ultimaFechaConceptoAnterior = null;

  cobrosConDescuento.forEach((cobro) => {
    const cuotas = cobro.cuotas;
    const montosCuotas = distribuirMontoEntero(cobro.monto, cuotas);

    // Fecha de inicio para este cobro
    let fechaActual;
    if (reglasInicio.tres_meses_despues_del_ultimo.includes(cobro.concepto_id)) {
      fechaActual = sumarMeses(ultimaFechaConceptoAnterior, 3);
    } else if (reglasInicio.despues_del_ultimo.includes(cobro.concepto_id) && ultimaFechaConceptoAnterior) {
      fechaActual = siguienteFecha(ultimaFechaConceptoAnterior);
    } else if (reglasInicio.fechas_nulas.includes(cobro.concepto_id) ) {
      fechaActual = null;
    } else {
      fechaActual = new Date(fechaInicio);
    }

    for (let i = 0; i < cuotas; i++) {
      plan.push({
        cobro_programa_id: cobro.cobro_programa_id,
        // concepto_pago_id: cobro.concepto_id,
        // descuento: 0,
        fecha_pago: formatFecha(fechaActual),
        monto: montosCuotas[i],
        nro_cuota: i + 1,
        xnombre: cobro.nombre,
      });

      if (i < cuotas - 1) {
        fechaActual = siguienteFecha(fechaActual);
      }
    }

    // Guardar ultima fecha de este concepto para el concepto_id=3
    if (cobro.concepto_id !== 3) {
      ultimaFechaConceptoAnterior = new Date(fechaActual);
    }
  });

  return {
    plan,
    plan_con_descuentos: cobrosConDescuento,
  };
};

const normalizarTexto = (texto) => {
  return String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase();
};

const esModuloTitulacion = (programaModulo) => {
  const nombre = normalizarTexto(programaModulo?.modulo?.nombre || programaModulo?.nombre);
  return Number(programaModulo?.numero) === 100 || nombre === 'MODULO DE TITULACION';
};

const obtenerModulosPlan = (programa) => {
  const mods = programa?.programa_modulo || programa?.programa_modulos || [];
  if(mods.length ==1){
    return mods;
  }
  
  return (mods)
    .filter((modulo) => !esModuloTitulacion(modulo) && modulo.numero > 0)
    .slice()
    .sort((a, b) => Number(a.numero || 0) - Number(b.numero || 0));
};

const obtenerFechaPagoModulo = (programaModulo, fechaFallback = null) => {
  const fechaInicio = parseFechaPrograma(programaModulo?.fecha_inicio);
  const fechaFin = parseFechaPrograma(programaModulo?.fecha_fin || programaModulo?.fecha_final);
  if (!fechaInicio || Number.isNaN(fechaInicio.getTime())) return fechaFallback;

  const fechaPago = new Date(fechaInicio);
  fechaPago.setDate(15);

  // if (fechaPago < fechaInicio) return fechaInicio;
  if (fechaFin && !Number.isNaN(fechaFin.getTime()) && fechaPago > fechaFin) return fechaFin;

  return fechaPago;
};

const prepararCobrosConDescuento = (promo, cobros) => {
  const cobrosConDescuento = ordenarCobrosPlan(JSON.parse(JSON.stringify(cobros)));
  if (promo && promo.detalle_promocion) {
    promo.detalle_promocion.forEach((p) => {
      const ex = cobrosConDescuento.find((c) => c.concepto_id == p.concepto_pago_id);
      if (ex) {
        let desc = 0;
        if (p.is_porcentaje) desc = parseFloat(ex.monto) * (Number(p.valor_descuento) / 100);
        else desc = parseFloat(p.valor_descuento);
        ex.monto = parseFloat(ex.monto) - desc;
        ex.promo_descuento = `${p.valor_descuento} ${p.is_porcentaje ? '%' : '$'} descuento`;
      }
    });
  }
  cobrosConDescuento.forEach((cobro) => {
    cobro.monto = normalizarMontoEntero(cobro.monto);
  });

  return cobrosConDescuento;
};

const obtenerIndiceModuloPorNumero = (modulosPlan, numeroModulo, indiceFallback = null) => {
  const index = modulosPlan.findIndex((modulo) => Number(modulo.numero) === numeroModulo);
  if (index >= 0) return index;
  return indiceFallback;
};

const generarPlanPorModulos = (promo, cobros, programa, usarCantidadModulos) => {
  const cobrosConDescuento = prepararCobrosConDescuento(promo, cobros);
  const reglasInicio = obtenerReglasInicioConceptos();
  const modulosPlan = obtenerModulosPlan(programa);
  const cantidadModulos = modulosPlan.length;
  const fechaHoy = new Date();
  const plan = [];
  let ultimaFechaConceptoAnterior = null;

  if (cantidadModulos === 0) {
    return {
      plan,
      plan_con_descuentos: cobrosConDescuento,
      cantidad_modulos: cantidadModulos,
    };
  }

  cobrosConDescuento.forEach((cobro) => {
    const montoTotal = parseFloat(cobro.monto);
    const dividePorModulos = Number(cobro.concepto_id) === 2;
    const cantidadCuotasCobro = dividePorModulos && usarCantidadModulos ? cantidadModulos : (Number(cobro.cuotas) || 1);
    const montosCuotas = distribuirMontoEntero(montoTotal, cantidadCuotasCobro);
    const usaFechaHoyInicial = [1, 2].includes(Number(cobro.concepto_id));
    const indiceModulo2 = obtenerIndiceModuloPorNumero(modulosPlan, 2, 1);

    let fechaActual;
    if (reglasInicio.fechas_nulas.includes(cobro.concepto_id)) {
      fechaActual = null;
    } else if (reglasInicio.tres_meses_despues_del_ultimo.includes(cobro.concepto_id) && ultimaFechaConceptoAnterior) {
      fechaActual = sumarMeses(ultimaFechaConceptoAnterior, 3);
    } else if (reglasInicio.despues_del_ultimo.includes(cobro.concepto_id) && ultimaFechaConceptoAnterior) {
      fechaActual = siguienteFecha(ultimaFechaConceptoAnterior);
    } else {
      fechaActual = new Date(fechaHoy);
    }
    let ultimaFechaCobro = null;

    for (let i = 0; i < cantidadCuotasCobro; i++) {
      let fechaPago = fechaActual;
      if (usaFechaHoyInicial && i === 0) {
        fechaPago = fechaHoy;
      } else if (dividePorModulos) {
        const offsetModulo = indiceModulo2 + i - (usaFechaHoyInicial ? 1 : 0);
        fechaPago = obtenerFechaPagoModulo(modulosPlan[offsetModulo], fechaActual);
      }
      ultimaFechaCobro = fechaPago ? new Date(fechaPago) : ultimaFechaCobro;

      plan.push({
        cobro_programa_id: cobro.cobro_programa_id,
        fecha_pago: formatFecha(fechaPago),
        monto: montosCuotas[i],
        nro_cuota: i + 1,
        xnombre: cobro.nombre,
      });

      if (i < cantidadCuotasCobro - 1) {
        fechaActual = siguienteFecha(fechaActual);
      }
    }

    if (!reglasInicio.tres_meses_despues_del_ultimo.includes(cobro.concepto_id) && ultimaFechaCobro) {
      ultimaFechaConceptoAnterior = ultimaFechaCobro;
    }
  });

  return {
    plan,
    plan_con_descuentos: cobrosConDescuento,
    cantidad_modulos: cantidadModulos,
  };
};

export const generar_plan_v2 = (promo, cobros, programa = null) => {
  return generarPlanPorModulos(promo, cobros, programa, true);
};

export const generar_plan_v3 = (promo, cobros, programa = null) => {
  return generarPlanPorModulos(promo, cobros, programa, false);
};
